import { render } from "./BulkRecycle.vue?vue&type=template&id=17cc3c5f&scoped=true"
import script from "./BulkRecycle.vue?vue&type=script&lang=ts"
export * from "./BulkRecycle.vue?vue&type=script&lang=ts"

import "./BulkRecycle.vue?vue&type=style&index=0&id=17cc3c5f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-17cc3c5f"

export default script